import React, { useEffect, useState } from "react";
import {
  getCompleteData,
  getItems,
  searchPart,
  getYears,
} from "../Home/EngineeringHome";
import NoData from "../../../components/NoData/Index";
import { Header } from "../../../components/SpearParts/Layouts/Header";
import { Footer } from "../../../components/SpearParts/Layouts/Footer";
import { SeachSection } from "../../../components/Engineering/Layout/SeachSection";
import { Link, useLocation, useNavigate } from "react-router-dom";
import EngineeringAdvancedSearch from "./EngineeringAdvanceSearch";
import { toTitleCase } from "../../../components/utils/StringUtil";
import EngMiddle from "../../../components/Engineering/Layout/EngMiddle";
import TopNavBar from "../../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../../components/SpearParts/Layouts/TopSearchBar";

function EngineeringCategory() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const [parts, setParts] = useState([]);
  const [engineeringCategory, setEngineeringCategory] = useState([]);
  const [engineeringBrand, setEngineeringBrand] = useState([]);
  const [engineeringModels, setEngineeringModels] = useState([]);
  const [region, setRegion] = useState([]);
  const [years, setYears] = useState([]);
  const [advResults, setAdvResults] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const getUniqueById = (arr) => {
    const seen = new Set();
    return arr.filter((item) => {
      if (seen.has(item._id)) return false;
      seen.add(item._id);
      return true;
    });
  };

  const uniqueParts = getUniqueById(parts);
  const uniqueAdvResults = getUniqueById(advResults);
  const getUniqueCategories = (arr) => {
    const seen = new Set();
    return arr.filter((item) => {
      const catId = item?.categoryId?._id;
      if (!catId || seen.has(catId)) return false;
      seen.add(catId);
      return true;
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (location.state) {
      // use cached data from state if present
      setEngineeringCategory(location.state.engineeringCategory || []);
      setEngineeringBrand(location.state.engineeringBrand || []);
      setEngineeringModels(location.state.engineeringModels || []);
      setRegion(location.state.region || []);
      setYears(location.state.years || []);
    } else if (
      !searchParams.get("brandId") &&
      !searchParams.get("categoryId")
    ) {
      // only fetch full data when no brand or category filter exists
      getCompleteData(
        setEngineeringBrand,
        setEngineeringCategory,
        setEngineeringModels
      );
      getItems(setRegion);
      setYears(getYears());
    }
  }, [location.state]);

  const filters = {
    categoryId: searchParams.get("categoryId"),
    brandId: searchParams.get("brandId"),
    manufacturerId: searchParams.get("manufacturerId"),
    // modelId: searchParams.get("modelId"),
    // year: searchParams.get("year"),
    // regionId: searchParams.get("regionId"),
  };
  useEffect(() => {
    searchPart(filters, currentPage, 15)
      .then((res) => {
        if (filters.categoryId) {
          setParts(res.data || []);
        } else {
          setEngineeringCategory(res.data || []);
        }
        setTotalPages(res.totalPages || 1);
      })
      .catch(() => {
        setParts([]);
        setEngineeringCategory([]);
      });
  }, [
    filters.categoryId,
    filters.brandId,
    filters.manufacturerId,
    currentPage,
  ]);

  const getModelName = (modelId) => {
    if (!modelId) return "Unknown Model";
    return (
      modelId?.name ||
      engineeringModels.find((m) => m._id === (modelId._id || modelId))?.name ||
      "Unknown Model"
    );
  };

  const getBrandName = (brandId) => {
    if (!brandId) return "Unknown Brand";
    // brandId may be a string or an object
    return (
      brandId?.name ||
      engineeringBrand.find((b) => b._id === (brandId._id || brandId))?.name ||
      "Unknown Brand"
    );
  };
  const getManufacturerName = (manufacturer) => {
    if (!manufacturer) return "Unknown Manufacturer";
    return manufacturer?.manufacturerName || "Unknown Manufacturer";
  };

  const getRegionName = (regionId) =>
    region.find((m) => m._id === regionId)?.name || "Unknown Region";

  const getCategoryName = (category) => category?.name || "Unknown Category";

  const PartCard = ({ product }) => (
    <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
      <Link
        to={`/engineering/product/single/${product._id}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div
          className="prod-div p-2 d-flex flex-column align-items-center"
          style={{
            border: "1px solid #ddd",
            borderRadius: "8px",
            height: "100%",
          }}
        >
          {product?.images?.length > 0 && (
            <img
              src={product.images[0].url}
              alt={product.partName}
              style={{
                width: "100%",
                height: "180px",
                objectFit: "contain",
                marginBottom: "60px",
              }}
            />
          )}

          <h6 className="mb-2 text-center">{toTitleCase(product.partName)}</h6>
        </div>
      </Link>
    </div>
  );
  const CategoryBoxCard = ({ category }) => {
    const hasSubcategories =
      category.subcategories && category.subcategories.length > 0;

    const handleClick = () => {
      if (hasSubcategories) {
        navigate(`/engineering/subcategories?categoryId=${category._id}`, {
          state: {
            category,
            subcategories: category.subcategories,
            selectedFilters: { ...filters, categoryId: category._id },
          },
        });
      } else {
        navigate(`/engineering/productlist?categoryId=${category._id}`, {
          state: {
            selectedFilters: { ...filters, categoryId: category._id },
          },
        });
      }
    };

    return (
      <div
        className="category-item"
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex flex-column align-items-center">
          {category?.images?.length > 0 && (
            <img src={category.images[0]} alt="Category" />
          )}
          <h6>{category.name}</h6>
        </div>
      </div>
    );
  };

    const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: "url(/images/bnr-bg.png)",
  };
  const beforeImageStyle = {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    width: "360px",
    height: "100%",
    backgroundImage: "url(/images/eng-head-image.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left top",
    backgroundSize: "contain",
    pointerEvents: "none",
    zIndex: 1,
  };


  return (
    <>
      <div className="New-Eng-Dashboard" style={sectionStyle}>
        {/* <Header /> */}
        <div className="before-image" style={beforeImageStyle}></div>
          <div className="Main-div">
            <TopNavBar />
            <div className="TopSearchBar">
              <TopSearchBar />
            </div>
            <div className="container">
              <div className="">
                <EngMiddle
                  initialFilters={{
                    categoryId: filters.categoryId,
                    brandId: filters.brandId,
                    manufacturerId: filters.manufacturerId,
                  }}
                  engineeringBrand={engineeringBrand}
                  engineeringCategory={engineeringCategory}
                  engineeringModels={engineeringModels}
                  region={region}
                  years={years}
                />
              </div>
              {/* Desktop layout: EngineeringAdvancedSearch left, results right */}
              <div className="">
                {/* <div className="col-lg-3">
              <EngineeringAdvancedSearch onResults={setAdvResults} />
            </div> */}
                <div className="col-lg-12">
                  <button
                    className="back btn btn-light"
                    onClick={() => navigate(-1)}
                    style={{
                      border: "none",
                      backgroundColor: "#dbe4f0ff",
                      padding: "8px 14px",
                      borderRadius: "6px",
                      cursor: "pointer",
                    }}
                  >
                    <i className="fa fa-long-arrow-left" aria-hidden="true"></i>{" "}
                    Back
                  </button>

                  <div className="table-responsive mt-3">
                    <table className="table product-table">
                      <tbody>
                        <tr>
                          <th style={{ backgroundColor: "#E9EEF4" }}>
                            &nbsp;{" "}
                          </th>
                          {/* <th style={{ backgroundColor: "#E9EEF4" }}>Brand</th>
                      <th style={{ backgroundColor: "#E9EEF4" }}>Model</th>
                      <th style={{ backgroundColor: "#E9EEF4" }}>Region</th>
                      <th style={{ backgroundColor: "#E9EEF4" }}>Year</th> */}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="category-grid">
                    {filters.categoryId ? (
                      uniqueParts.length > 0 ? (
                        uniqueParts.map((product, index) => (
                          <PartCard key={index} product={product} />
                        ))
                      ) : (
                        <div className="col-12 text-center py-4">
                          <NoData />
                        </div>
                      )
                    ) : engineeringCategory.length > 0 ? (
                      engineeringCategory.map((category, index) => (
                        <CategoryBoxCard key={index} category={category} />
                      ))
                    ) : (
                      <div className="col-12 text-center py-4">
                        <NoData />
                      </div>
                    )}
                  </div>

                  {/* Advanced search results */}
                  {/* {advResults.length > 0 && (
                <>
                  <h5 className="mt-4 mb-3">Advanced Search Results</h5>
                  <div className="row">
                    {uniqueAdvResults.map((product, index) => (
                      <PartCard key={index} product={product} />
                    ))}
                  </div>
                </>
              )} */}
                </div>
              </div>

              {/* Mobile/Tablet layout */}
              <div
                className="d-block d-lg-none"
                style={{
                  marginTop: "-13%",
                  paddingTop: "6rem",
                  paddingBottom: "2rem",
                }}
              >
                <Link to="/" className="back">
                  <i className="fa fa-long-arrow-left" aria-hidden="true"></i>{" "}
                  Back
                </Link>
                <div className="table-responsive mt-3">
                  <table className="table product-table">
                    <tbody>
                      <tr>
                        <th style={{ backgroundColor: "#E9EEF4" }}>&nbsp;</th>
                        {/* <th style={{ backgroundColor: "#E9EEF4" }}>Brand</th>
                    <th style={{ backgroundColor: "#E9EEF4" }}>Model</th>
                    <th style={{ backgroundColor: "#E9EEF4" }}>Region</th>
                    <th style={{ backgroundColor: "#E9EEF4" }}>Year</th> */}
                      </tr>
                      {parts.length > 0 ? (
                        uniqueParts.map((product, index) => (
                          <tr key={index}>
                            <td>{toTitleCase(product.partName)}</td>
                            <td>
                              {toTitleCase(getBrandName(product.brandId))}
                            </td>
                            <td>
                              {toTitleCase(getModelName(product.modelId))}
                            </td>
                            <td>
                              {toTitleCase(getRegionName(product.regionId))}
                            </td>
                            <td>{product.year}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="7"
                            rowSpan="5"
                            className="text-center py-4"
                          >
                            <NoData />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="row product-list gutter-7">
                  {filters.categoryId ? (
                    uniqueParts.length > 0 ? (
                      uniqueParts.map((product, index) => (
                        <PartCard key={index} product={product} />
                      ))
                    ) : (
                      <div className="col-12 text-center py-4">
                        <NoData />
                      </div>
                    )
                  ) : engineeringCategory.length > 0 ? (
                    engineeringCategory.map((category, index) => (
                      <CategoryBoxCard key={index} category={category} />
                    ))
                  ) : (
                    <div className="col-12 text-center py-4">
                      <NoData />
                    </div>
                  )}
                </div>

                {/* <div className="mt-4">
              <EngineeringAdvancedSearch onResults={setAdvResults} />
              {advResults.length > 0 && (
                <>
                  <h5 className="mt-4 mb-3">Advanced Search Results</h5>
                  <div className="row">
                    {uniqueAdvResults.map((product, index) => (
                      <PartCard key={index} product={product} />
                    ))}
                  </div>
                </>
              )}
            </div> */}
                <div className="pagination-container d-flex justify-content-end align-items-center mt-4">
                  <button
                    className="pagination-btn"
                    disabled={currentPage === 1}
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                  >
                    <i className="fa fa-arrow-left"></i>
                  </button>

                  <span className="mx-3">
                    {currentPage} of {totalPages}
                  </span>

                  <button
                    className="pagination-btn"
                    disabled={currentPage === totalPages}
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                  >
                    <i className="fa fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

        {/* <Footer /> */}
      </div>
    </>
  );
}
export default EngineeringCategory;
